import { render, staticRenderFns } from "./PlanStopView.vue?vue&type=template&id=36cad3c2&"
import script from "./PlanStopView.vue?vue&type=script&lang=js&"
export * from "./PlanStopView.vue?vue&type=script&lang=js&"
import style0 from "./PlanStopView.vue?vue&type=style&index=0&id=36cad3c2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports